<template>
  <section id="country-tab-description" class="wrapper-tab-description">
    <p>{{ country.description }}</p>
  </section>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'LadSearchTabDescription',
  computed: {
    ...mapState('country', {
      country: (state) => ({ description: state.header.description }),
    }),
  },
}
</script>

<style lang="scss">
section.wrapper-tab-description {
  /** */
}
</style>
